import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/reset.css'
import VueI18n from 'vue-i18n'
import "vue-material-design-icons/styles.css"
import echarts from 'echarts';
import VueAMap from 'vue-amap';
import axios from "./http";
import VueAxios from "vue-axios";
import zhLocale from './assets/lang/zh';
import enLocale from './assets/lang/en';
import './assets/js/directives.js'
import Router from 'vue-router'
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';

require('./assets/js/setSize.js')
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(VueI18n);
Vue.use(VueAMap);
Vue.use(VueAxios, axios);
Vue.use(Router)
Vue.use(Avue);

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts;

VueAMap.initAMapApiLoader({
  key: '698176928de13344f7551e8fca7db745',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
});

const i18n = new VueI18n({
  locale: 'en', // 语言标识
  messages: {
    'zh': zhLocale,
    'en': enLocale
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
